export const globalLoginState = {
  isProcessingLogin: false,
}
